import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "daster",
  style: {"padding":"0 30px"}
}
const _hoisted_2 = { class: "d-flex flex-wrap flex-stack mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold my-2 d-none" }, " Representantes ", -1)
const _hoisted_4 = { class: "d-flex my-2" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative" }
const _hoisted_6 = { class: "svg-icon svg-icon-3 position-absolute ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            type: "text",
            class: "form-control form-control-white form-control-sm w-300px ps-9",
            placeholder: "Buscar"
          }, null, 512), [
            [_vModelText, _ctx.search]
          ])
        ])
      ])
    ]),
    (_ctx.listRepam.length > 0)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: _ctx.listRepam,
          border: "",
          "table-layout": 'auto'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "idrepman",
              label: "ID",
              width: "80",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "person",
              label: "Nombres y apellidos"
            }),
            _createVNode(_component_el_table_column, {
              prop: "function_name",
              label: "Cargo"
            }),
            _createVNode(_component_el_table_column, {
              prop: "function_name",
              label: "Estado"
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "Registrado"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loader]
        ])
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "No se encontrarón resultados"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("Volver a intentar")
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loader]
        ])
  ]))
}